"use strict";

exports.PricingUtility = void 0;
var _ProtocolError = require("./data/errors/ProtocolError");
var _sdkTypes = require("./data/sdk-types");
var _logger = require("./logger");
var _DexScreenerHttpRepository = require("./repositories/DexScreenerHttpRepository");
class PricingUtility {
  constructor(props) {
    if (!props) {
      throw new _ProtocolError.ProtocolError('props are required', {
        component: _sdkTypes.ErrorContextComponent.SDK_PRICING_UTILITY,
        description: 'Props required to initialize PricingUtility were not provided'
      });
    }
    this.logger = new _logger.Logger('@presend/verification/pricing-util', props.debug);
    this.dexScreenerHttpRepo = new _DexScreenerHttpRepository.DexScreenerHttpRepository();
  }

  /**
   * Gets the current USD price of a token by its address.
   *
   * @param {string} tokenAddress - The address of the token.
   * @param {string} symbol - The symbol of the token, optional but recommended to narrow down pair (especially with stable coin)
   * @return {Promise<number>} - The current price of the token.
   */
  async getPriceForTokenAddressAsync(tokenAddress, symbol) {
    this.logger.debug('Getting Price for token Address', tokenAddress);
    const price = await this.dexScreenerHttpRepo.getPriceForTokenAddressAsync(tokenAddress, symbol);
    this.logger.debug('Got Price for token Address', price);
    return price;
  }

  /**
   * Gets the current price of a trading pair.
   *
   * @param {string} pair - The trading pair, in the format "baseToken quoteToken".
   * @return {Promise<number>} - The current price of the trading pair.
   */
  async getPriceForPairAsync(pair) {
    this.logger.debug('Getting Price for Pair', pair);
    const price = await this.dexScreenerHttpRepo.getPriceForPairAsync(pair);
    this.logger.debug('Got Price for Pair', price);
    return price;
  }
}
exports.PricingUtility = PricingUtility;